import AnnouncementTable from './AnnouncementsTable';

export default AnnouncementTable;
